/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.flotante-whatsapp[_ngcontent-%COMP%]{position:fixed;bottom:30px;left:15px;width:70px;height:70px;z-index:90}div.flotante-whatsapp[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}div.flotante-whatsapp[_ngcontent-%COMP%]:hover{bottom:30px}@media (max-width:767px){div.flotante-whatsapp[_ngcontent-%COMP%]{width:50px;height:50px}}"];
export { styles as styles };
